import { render, staticRenderFns } from "./RegistrationStepThree.vue?vue&type=template&id=6d7a8dea&scoped=true&"
import script from "./RegistrationStepThree.vue?vue&type=script&lang=js&"
export * from "./RegistrationStepThree.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationStepThree.vue?vue&type=style&index=0&id=6d7a8dea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7a8dea",
  null
  
)

export default component.exports